import {
  PeopleIcon,
  StackedBarChartIcon,
  FaceRetouchingNaturalIcon,
} from '@assets/icons';
import { useAppDispatch } from '@hooks';
import {
  AppBar,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import { toggleMenu } from '@redux/actions';
import { Routes } from '@utils/constants';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import './Menu.scss';
import { t } from 'i18next';

const MenuItem: IMenuItem[] = [
  {
    route: Routes.DASHBOARD,
    text: 'menu.dashboard',
    icon: StackedBarChartIcon,
  },
  {
    route: Routes.FACE_IDS_PRIVATE,
    text: 'menu.private_face_ids',
    icon: FaceRetouchingNaturalIcon,
  },
  {
    route: Routes.FACE_IDS_CLUSTERED,
    text: 'menu.cluster_face_ids',
    icon: FaceRetouchingNaturalIcon,
  },
  {
    route: Routes.MEMBER_LIST,
    text: 'menu.member_list',
    icon: PeopleIcon,
  },
];

const DrawerMenu: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClick = (item: IMenuItem) => () => {
    if (location.pathname !== item.route) {
      navigate(item.route);
    }
  };

  return (
    <Box
      className="Menu__list"
      sx={{ width: 350 }}
      role="presentation"
      onClick={() => dispatch(toggleMenu())}
    >
      <AppBar position="static" className="Menu__header">
        <Typography variant="h4">Timeline Application</Typography>
      </AppBar>
      <List disablePadding>
        {MenuItem.map((item) => (
          <ListItem key={item.route} disablePadding className="MenuItem">
            <ListItemButton
              className="MenuItem__content"
              sx={{ justifyContent: 'initial' }}
              selected={location.pathname.includes(item.route)}
              onClick={handleClick(item)}
            >
              <ListItemIcon className="MenuItem__content__icon" sx={{ mr: 2 }}>
                <item.icon />
              </ListItemIcon>
              <ListItemText
                className="MenuItem__text"
                primary={t(item.text)}
                sx={{ opacity: 1 }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default DrawerMenu;
